import { render, staticRenderFns } from "./DelMapping.vue?vue&type=template&id=3bd89faf&scoped=true"
import script from "./DelMapping.vue?vue&type=script&lang=js"
export * from "./DelMapping.vue?vue&type=script&lang=js"
import style0 from "./DelMapping.vue?vue&type=style&index=0&id=3bd89faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd89faf",
  null
  
)

export default component.exports